import { Injectable } from '@angular/core';
import { CanActivate } from "@angular/router";
import { AppGlobals } from './Services/app.global';

@Injectable()
export class ActivateRoutes_ID_Guard implements CanActivate {
    //used to validate route with id
    constructor(private appGlobal: AppGlobals) { }
    canActivate() {
        if (this.appGlobal.routeWithID == true) {
            return true;
        }
        else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/activate-route_ID-guard.ts